import React, { Component } from 'react'
import { Redirect } from 'react-router'
import {
  Button, ButtonDropdown, ButtonGroup, ButtonToolbar,
  Card, CardBody, CardFooter, CardHeader, CardTitle,
  Row, Col,
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
  Progress, Tooltip,
} from 'reactstrap'
import CustomBar from '../../CustomComponents/CustomBar'
import { ReactSVG } from 'react-svg'

const styles = {
	topCard: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		background: 'rgba(148, 148, 148, 0.15)',
		border: 0,
		backdropFilter: 'blur(10px)',
	}
}

function determineColor(score){
	if(score < 50){
		return 'icon-awas'
	} else if(score > 75){
		return 'icon-siaga'
	} else {
		return 'icon-waspada'
	}
}

const unitData = [
	{
		id: 0,
		groupName: 'RANPUR/KENDARAAN TEMPUR/BERODA RANTAI',
		typeName: 'MBT LEOPARD',
		serialNumber: 192746,
		age: 324,
		condition: 78,
	},
	{
		id: 3,
		groupName: 'RANPUR/KENDARAAN TEMPUR/BERODA RANTAI',
		typeName: 'MBT LEOPARD',
		serialNumber: 192746,
		age: 324,
		condition: 78,
	},
	{
		id: 8,
		groupName: 'RANPUR/KENDARAAN TEMPUR/BERODA RANTAI',
		typeName: 'MBT LEOPARD',
		serialNumber: 192746,
		age: 324,
		condition: 78,
	},
	{
		id: 10,
		groupName: 'RANPUR/KENDARAAN TEMPUR/BERODA RANTAI',
		typeName: 'MBT LEOPARD',
		serialNumber: 192746,
		age: 324,
		condition: 78,
	},
	{
		id: 22,
		groupName: 'RANPUR/KENDARAAN TEMPUR/BERODA RANTAI',
		typeName: 'MBT LEOPARD',
		serialNumber: 192746,
		age: 324,
		condition: 78,
	},
]

class Wall extends Component {
	constructor(props){
		super(props)
		this.state = {
			drilldown: false,
			tooltipOpen: {
				siaga: false,
				waspada: false,
				awas: false,
			},
			itemHover1: {background: 'rgba(203, 203, 203, 0.15)'},
			itemHover2: {background: 'rgba(203, 203, 203, 0.15)'},
			itemHover3: {background: 'rgba(203, 203, 203, 0.15)'},
			itemHover4: {background: 'rgba(203, 203, 203, 0.15)'},
		}
	}

	showCard = (_color, _title, _number, _condition) => {
		return(
			<Card style={{color: _color, ...styles.topCard}}>
				<p style={{fontWeight: 700, marginTop: '12px', marginLeft: '14px'}}>{_title}</p>
				<p id={_title} style={{fontSize: '48px', marginTop: '8px', marginBottom: '8px', marginRight: '16px'}}>{_number}</p>

				<Tooltip placement="bottom" isOpen={this.state.tooltipOpen.siaga} target={'SIAGA'}
					toggle={() => this.setState({tooltipOpen: {siaga: !this.state.tooltipOpen.siaga}})}>
					Status <b style={{color: '#16D02C'}}>SIAGA</b> adalah status unit atau armada dengan kondisi unit diatas 75%.
				</Tooltip>
				<Tooltip placement="bottom" isOpen={this.state.tooltipOpen.waspada} target={'WASPADA'}
					toggle={() => this.setState({tooltipOpen: {waspada: !this.state.tooltipOpen.waspada}})}>
					Status <b style={{color: '#FFC402'}}>WASPADA</b> adalah status unit atau armada dengan kondisi unit diatas 50% dan dibawah 75%.
				</Tooltip>
				<Tooltip placement="bottom" isOpen={this.state.tooltipOpen.awas} target={'AWAS'}
					toggle={() => this.setState({tooltipOpen: {awas: !this.state.tooltipOpen.awas}})}>
					Status <b style={{color: '#FB3C00'}}>AWAS</b> adalah status unit atau armada dengan kondisi unit dibawah 50%.
				</Tooltip>
			</Card>
		)
	}

	showListGroup = () => {
		const { data, counter } = this.props
		return(
			<div className='animated fadeIn' style={{margin: '12px'}}>
				{counter.length>0?<Row>
					<Col md='4' id="siaga">
						{this.showCard('#16D02C', 'SIAGA', counter[0].counter)}
					</Col>
					<Col md='4' id="waspada">
						{this.showCard('#FFC402', 'WASPADA', counter[1].counter)}
					</Col>
					<Col md='4' id="awas">
						{this.showCard('#FB3C00', 'AWAS', counter[2].counter)}
					</Col>
				</Row>:null}
				{data.length>0?<Row style={{height: '600px', overflowY: 'auto', marginRight: 0}}>
					<Col>
						{data.map((group, index) => (
							<div>
								<p style={{color: '#fff', fontSize: '18px', marginBottom: '8px'}}>{group.sub_group_name} {group.type_name}</p>
								{this.showListType(group.sub_type_data)}
							</div>
						))}
					</Col>
				</Row>:null}
			</div>
		)
	}

	showListType = (_data) => {
		return(
			<Row>
				{_data.map((type, index) => (
					<Col md='6'>
						<Card onClick={() => this.toggleDrilldown(type.unit_data)}
							style={{background: 'rgba(200, 200, 200, 0.15)', backdropFilter: 'blur(10px)', border: 0, color: '#fff'}}>
							<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '8px'}}>
								<p style={{margin: 0}}>{type.sub_type_name}</p>
								<p style={{margin: 0}}>{type.alert_counter[0]}/{type.alert_counter[1]}/{type.alert_counter[2]}</p>
							</div>
							<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '8px'}}>
              					{type.sub_type_icon && <img src={require('../../../assets/units/' + type.sub_type_icon + '.svg')} width="60" style={{marginRight: '20px'}}/>}
								<CustomBar type="multi"
								value={[
									Math.ceil(type.alert_counter[0]*100/(type.alert_counter[0]+type.alert_counter[1]+type.alert_counter[2])),
									Math.ceil(type.alert_counter[1]*100/(type.alert_counter[0]+type.alert_counter[1]+type.alert_counter[2])),
									Math.ceil(type.alert_counter[2]*100/(type.alert_counter[0]+type.alert_counter[1]+type.alert_counter[2])),
								]}
								backgroundColor="none" />
							</div>
						</Card>
					</Col>
				))}
			</Row>
		)
	}

	showListUnit = () => {
		const { isSorting, sortMode, dropdownHack, activeSubType, activeUnit, redirect, itemHover1, itemHover2, itemHover3, itemHover4 } = this.state
		const { data } = this.props

		if(redirect){
			return <Redirect push to={'/unit/details/' + activeUnit} />
		}

		switch(sortMode){
			case 'Rentang waktu umur terbanyak':
				activeSubType.sort((x,y) => (x.duration_year*x.duration_month < y.duration_year*y.duration_month)?1:-1)
			break;
			case 'Rentang waktu umur tersedikit':
				activeSubType.sort((x,y) => (x.duration_year*x.duration_month > y.duration_year*y.duration_month)?1:-1)
			break;
			case 'Unit paling siap':
				activeSubType.sort((x,y) => (x.performance_score < y.performance_score)?1:-1)
			break;
			case 'Unit kurang siap':
				activeSubType.sort((x,y) => (x.performance_score > y.performance_score)?1:-1)
			break;
			default:
		}

		return(
			<div className='animated fadeIn'>
				<Row>
					<Col style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', marginTop: '16px', marginBottom: '16px', marginLeft: '20px', marginRight: '20px'}}>
                    	<i class="fa fa-long-arrow-left" style={{fontSize: 20, color: '#fff', cursor: 'pointer'}} onClick={() => this.setState({drilldown: !this.state.drilldown})}></i>
                    	<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline'}}>
                    		<p style={{color: '#fff', marginRight: '12px'}}>Urutkan berdasarkan</p>
                    		<Dropdown isOpen={isSorting} toggle={() => this.toggleSort()}  style={{color: "#fff", backgroundColor: 'rgba(203, 203, 203, 0.15)', border: '1px solid #9F9F9F', backdropFilter: 'blur(10px)'}} >
					            <DropdownToggle style={{color: "#fff", backgroundColor: 'rgba(203, 203, 203, 0.15)', border: '1px solid #9F9F9F', backdropFilter: 'blur(10px)'}} caret>
					            	{sortMode}
					            </DropdownToggle>
						        <DropdownMenu style={{color: '#fff', background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(10px)', border: '1px solid #9F9F9F'}} right>
						            <DropdownItem
						            	style={{color: '#fff', backdropFilter: 'blur(10px)', border: 0, ...itemHover1}}
						            	onClick={() => this.setState({sortMode: 'Rentang waktu umur terbanyak'})}
						            	onMouseEnter={() => this.setState({itemHover1: {background: 'rgba(203, 203, 203, 1)', color: '#000'}})}
						            	onMouseLeave={() => this.setState({itemHover1: {background: 'rgba(203, 203, 203, 0.15)'}})}>
						            	Rentang waktu umur terbanyak
						            </DropdownItem>
						            <DropdownItem
						            	style={{color: '#fff', backdropFilter: 'blur(10px)', border: 0, ...itemHover2}}
						            	onClick={() => this.setState({sortMode: 'Rentang waktu umur tersedikit'})}
						            	onMouseEnter={() => this.setState({itemHover2: {background: 'rgba(203, 203, 203, 1)', color: '#000'}})}
						            	onMouseLeave={() => this.setState({itemHover2: {background: 'rgba(203, 203, 203, 0.15)'}})}>
						            	Rentang waktu umur tersedikit
						            </DropdownItem>
						            <DropdownItem
						            	style={{color: '#fff', backdropFilter: 'blur(10px)', border: 0, ...itemHover3}}
						            	onClick={() => this.setState({sortMode: 'Rentang waktu umur tersedikit'})}
						            	onMouseEnter={() => this.setState({itemHover3: {background: 'rgba(203, 203, 203, 1)', color: '#000'}})}
						            	onMouseLeave={() => this.setState({itemHover3: {background: 'rgba(203, 203, 203, 0.15)'}})}>
						            	Unit paling siap
						            </DropdownItem> 
						            <DropdownItem
						            	style={{color: '#fff', backdropFilter: 'blur(10px)', border: 0, ...itemHover4}}
						            	onClick={() => this.setState({sortMode: 'Rentang waktu umur tersedikit'})}
						            	onMouseEnter={() => this.setState({itemHover4: {background: 'rgba(203, 203, 203, 1)', color: '#000'}})}
						            	onMouseLeave={() => this.setState({itemHover4: {background: 'rgba(203, 203, 203, 0.15)'}})}>
						            	Unit kurang siap
						            </DropdownItem>    
					            </DropdownMenu>
				            </Dropdown>
                    	</div>
                    </Col>
				</Row>
				<div style={{height: '640px', overflowY: 'auto', marginLeft: 0, marginRight: '20px', marginBottom: '12px', zIndex: -1, ...dropdownHack}}>
					{activeSubType.map((unit, index) => (
						<Row style={{margin: 0, marginBottom: '8px'}}>
							{}
							<Col>
								<Card style={{background: 'rgba(200, 200, 200, 0.15)', color: '#fff', justifyContent: 'space-between', marginBottom: 0, border: 0}}
								onClick={() => this.setState({activeUnit: unit.unit_id}, this.setState({redirect: true}))}>
									<Row>
										<Col md='2'>
											{unit.sub_type_icon &&
												<ReactSVG src={require('../../../assets/units/'+unit.sub_type_icon+'.svg')} className={determineColor(unit.performance_score) + ' icon-dashboard'} />
											}
										</Col>
										<Col md='4'>
											<div style={{margin: '16px'}}>
												<p style={{color: '#18A0FB', marginBottom: 0, fontSize: '12px'}}>{unit.sub_group_name}</p>
												<p style={{marginBottom: 0}}>{unit.sub_type_name} No. {unit.unit_no}</p>
											</div>
										</Col>
										<Col md='3'>
											<div style={{margin: '16px'}}>
												<p style={{color: '#18A0FB', marginBottom: 0}}>Rentang Waktu Umur</p>
												<div style={{display: 'flex', flexDirection: 'row'}}>
													{unit.duration_year>0?<p style={{marginBottom: 0, marginRight: '10px'}}>{unit.remaining_year} Tahun</p>:null}
													<p style={{marginBottom: 0}}>{unit.remaining_month} Bulan</p>
												</div>
											</div>
										</Col>
										<Col md='3'>
											<div style={{margin: '16px', textAlign: 'right'}}>
												<p style={{color: '#18A0FB', marginBottom: 0}}>Kesiapan Unit</p>
												{/* {unit.performance_score != null?<p style={{marginBottom: 0}}>{unit.performance_score}%</p>:null} */}
												<p style={{marginBottom: 0}}>{unit.performance_score}%</p>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>
						</Row>
					))}
				</div>
			</div>
		)
	}

	showBackToDivision = () => {
		return(
			<div className='animated fadeIn' style={{display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '24px'}}>
				<i class="fa fa-long-arrow-left" style={{fontSize: 20, color: '#fff', cursor: 'pointer', marginRight: '32px'}} onClick={() => this.props.onBack()}></i>
				<img src={this.props.divisionLogo} alt={this.props.divisionName} width="48" />
				<h2 style={{color: '#fff', marginLeft: '24px'}}>{this.props.divisionName}</h2>
			</div>
		)
	}

	toggleSort = () => {
		if(this.state.isSorting){
			this.setState({
				isSorting: !this.state.isSorting,
				dropdownHack: {position: 'initial'}
			})
		} else {
			this.setState({
				isSorting: !this.state.isSorting,
				dropdownHack: {position: 'relative'}
			})
		}
	}

	toggleDrilldown = (_unit) => {
		if(!this.props.disableDrilldown){
			this.setState({
				drilldown: !this.state.drilldown,
				activeSubType: _unit
			})
		}
	}

	backToDivision = () => {
		this.props.onBack(false)
	}

	handleTypeClick = () => {
		this.setState({drilldown: !this.state.drilldown})
	}

	render(){
		const { drilldown } = this.state
		const { disableDrilldown } = this.props
		return(
			<div className='animated fadeIn'>
				<Card style={{background: 'rgba(148, 148, 148, 0.15)', border: '1px solid #9F9F9F', backdropFilter: 'blur(10px)'}}>
					{disableDrilldown?this.showBackToDivision():null}
					{drilldown?this.showListUnit():this.showListGroup()}
				</Card>
			</div>
		)
	}
}

export default Wall


// WEBPACK FOOTER //
// ./src/views/Dashboard/utils/Wall.jsx